import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { InputParameters, size, variant } from "../InputParameters";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

export interface InputPasswordParameters extends InputParameters {
  obscureMode?: boolean;
}

const DEFAULT_PARAMENTERS: InputPasswordParameters = {
  id: undefined,
  label: "",
  size: size.small,
  variant: variant.outlined,
  fullWidth: false,
  type: "password",
  obscureMode: false,
};

const InputPassword = (inputParameters: InputPasswordParameters) => {
  const [obscure, setObscure] = React.useState(true);
  const [type, setType] = React.useState("password");

  let _parameters: any = { ...DEFAULT_PARAMENTERS, ...inputParameters };

  const handleObscure = () => {
    setObscure(!obscure);
    obscure ? setType("password") : setType("text");
  };
  _parameters.type = type;

  if (_parameters.sufix) {
    _parameters.InputProps = {
      ...{
        endAdornment: (
          <InputAdornment position="end">{_parameters.sufix}</InputAdornment>
        ),
      },
    };
  }

  if (_parameters.prefix) {
    _parameters.InputProps = {
      ...{
        startAdornment: (
          <InputAdornment position="start">{_parameters.prefix}</InputAdornment>
        ),
      },
    };
  }

  if (_parameters.obscureMode) {
    _parameters.InputProps = {
      ...{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="toggle password visibility"
              onClick={handleObscure}
              edge="end"
            >
              {obscure ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      },
    };
  }

  delete _parameters.obscureMode;
  return <TextField {..._parameters} />;
};

export { InputPassword };
